import { Socket } from 'phoenix'
import { API_URL, SOCKET_SCHEME } from '@services/.env'
import { ENV } from '@src/constants/general-constants.js'

export default {
  install(app, options) {
    // Notifier Socket
    app.config.globalProperties.$connectSocket = (url, token) => {
      const socketConfig = {
        params: { token },
      }
      if (process.env.VUE_APP_FEATURES_ENVIRONMENT === ENV.DEV) {
        socketConfig.logger = (kind, msg, data) => {
          console.log(`${kind}: ${msg}`, data)
        }
      }
      const socket = new Socket(`${SOCKET_SCHEME}://${API_URL}${url}`, socketConfig)

      socket.connect()
      socket.channel(url)

      socket.onError(() => {
        socket.disconnect()
      })

      app.config.globalProperties.$socket = socket
    }

    // Tenant socket

    app.config.globalProperties.$connectApiSocket = function (url, token) {
      const socket = new Socket(`${SOCKET_SCHEME}://${API_URL}${url}`, {
        params: { token },
      })

      socket.connect()
      socket.channel(url)

      socket.onError(() => {
        socket.disconnect()
      })

      app.config.globalProperties.$apiSocketChannel = socket
    }

    // Public socket for tenant setup notifications
    app.config.globalProperties.$connectPublicSocket = function (otp, email, callbacks) {
      // Phoenix automatically appends /websocket, so we use /public-socket
      const socketUrl = `${SOCKET_SCHEME}://${API_URL}/public-socket`
      const socket = new Socket(socketUrl, {
        params: { otp, email },
      })

      socket.connect()

      // Channel topic uses email as identifier
      const channel = socket.channel(`setup_progress`, {})

      channel
        .join()
        .receive('ok', (resp) => {
          console.log('Joined tenant notification channel', resp)
          // Pass the response which may contain current status
          if (callbacks?.onJoin) callbacks.onJoin(resp)
        })
        .receive('error', (resp) => {
          console.error('Unable to join tenant notification channel', resp)
          if (callbacks?.onError) callbacks.onError(resp)
        })

      // Listen for tenant setup events
      channel.on('tenant-setup-queued', (payload) => {
        console.log('[Public Socket] Event received: tenant-setup-queued', payload)
        if (callbacks?.onQueued) callbacks.onQueued(payload)
      })

      channel.on('tenant-setup-migration-started', (payload) => {
        console.log('[Public Socket] Event received: tenant-setup-migration-started', payload)
        if (callbacks?.onMigrationStarted) callbacks.onMigrationStarted(payload)
      })

      channel.on('tenant-setup-migration-completed', (payload) => {
        console.log('[Public Socket] Event received: tenant-setup-migration-completed', payload)
        if (callbacks?.onMigrationCompleted) callbacks.onMigrationCompleted(payload)
      })

      channel.on('tenant-setup-seeding-started', (payload) => {
        console.log('[Public Socket] Event received: tenant-setup-seeding-started', payload)
        if (callbacks?.onSeedingStarted) callbacks.onSeedingStarted(payload)
      })

      channel.on('tenant-setup-completed', (payload) => {
        console.log('[Public Socket] Event received: tenant-setup-completed', payload)
        if (callbacks?.onCompleted) callbacks.onCompleted(payload)
      })

      channel.on('tenant-setup-failed', (payload) => {
        console.log('[Public Socket] Event received: tenant-setup-failed', payload)
        if (callbacks?.onFailed) callbacks.onFailed(payload)
      })

      socket.onError((error) => {
        console.error('[Public Socket] Socket error:', error)
        socket.disconnect()
        if (callbacks?.onError) {
          callbacks.onError(error)
        }
      })

      socket.onClose(() => {
        console.log('[Public Socket] Socket closed')
        // Only clear status if setup is not completed/failed
        // (completed/failed states are handled by their respective callbacks)
      })

      app.config.globalProperties.$publicSocket = socket
      app.config.globalProperties.$publicSocketChannel = channel

      return { socket, channel }
    }
  },
}
